import { DangerButton, SecondaryButton } from '@shared/components/buttons';
import { Modal } from '@shared/components/modal';

type CancelSessionModalProps = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  body: React.ReactNode;
};

export function CancelSessionModal({ visible, onClose, onConfirm, body }: CancelSessionModalProps) {
  return (
    <Modal
      title="Cancel Receiving Session"
      visible={visible}
      onClose={onClose}
      size="sm"
      footer={
        <>
          <SecondaryButton onClick={onClose}>Keep Session</SecondaryButton>
          <DangerButton onClick={onConfirm}>Cancel Session</DangerButton>
        </>
      }
    >
      <div className="text-sm text-gray-600">{body}</div>
    </Modal>
  );
}
